module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag-container"
  }, [(_vm.title) ? _c('h2', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "drag-list"
  }, _vm._l((_vm.stages), function(stage) {
    var _obj;

    return _c('li', {
      key: stage,
      staticClass: "drag-column",
      class: ( _obj = {}, _obj['drag-column-' + stage] = true, _obj )
    }, [_c('span', {
      staticClass: "drag-column-header"
    }, [_vm._t(stage, [_c('b', {
      staticStyle: {
        "color": "ivory"
      }
    }, [_vm._v(_vm._s(_vm.formatStage(stage)))])])], 2), _vm._v(" "), _c('div', {
      staticClass: "drag-options"
    }), _vm._v(" "), _c('ul', {
      ref: "list",
      refInFor: true,
      staticClass: "drag-inner-list",
      attrs: {
        "data-status": stage
      }
    }, _vm._l((this.localBlocks), function(card, index) {
      return _c('li', {
        key: index,
        staticClass: "drag-item",
        attrs: {
          "data-block-id": card.id
        }
      }, [_vm._t(card.id, [_c('kanban-card', {
        attrs: {
          "v-model": card
        }
      })])], 2)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "drag-column-footer"
    }, [_vm._t(("footer-" + stage))], 2)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c712229"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/KanbanBoard.vue
// module id = 1621
// module chunks = 0